import React from 'react';
import { Link } from 'react-router-dom';
import './PlanRequired.css';

const COPY = {
  library: { title: 'This one’s for members', body: 'Join a membership plan to watch the full video, breakdowns and variations.' },
  feedback: { title: 'Video feedback is part of membership', body: 'Join a plan that includes feedback to send your instructors a video of yourself.' },
  live: { title: 'Live classes are part of membership', body: 'Join a plan that includes live classes to watch them live and catch the replays.' },
} as const;

interface PlanRequiredProps {
  perk: keyof typeof COPY;
  compact?: boolean;
}

/** Shown where a studio's paid plans gate something the member doesn't have yet. */
const PlanRequired: React.FC<PlanRequiredProps> = ({ perk, compact }) => {
  const { title, body } = COPY[perk];
  return (
    <div className={`plan-required ${compact ? 'plan-required--compact' : ''}`} role="note">
      <span className="plan-required-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
          <path d="M18 8h-1V6A5 5 0 0 0 7 6v2H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2zm-6 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm3.1-9H8.9V6a3.1 3.1 0 0 1 6.2 0v2z" />
        </svg>
      </span>
      <div className="plan-required-text">
        <strong>{title}</strong>
        {!compact && <p>{body}</p>}
      </div>
      <Link to="/join" className="btn btn-primary btn-small">See plans</Link>
    </div>
  );
};

export default PlanRequired;
